import React from "react";
/** Components Import */
import BasicDatepicker from "./Datepicker_Basic";
import BasicCombo from "./Combo_Basic";
import BasicRadio from "./Radio_Basic";
import GroupCheckbox from "./Checkbox_Group";
import BasicButton from "./Button_Basic";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRotateRight as RefreshIcon,
  faMagnifyingGlass as SearchIcon,
  faPlus as AddIcon,
  faFloppyDisk as SaveIcon,
  faTrash as DeleteIcon,
  faCircleCheck as ExcelIcon,
} from "@fortawesome/free-solid-svg-icons";

function FormGroup({ datas = [], columnCount = 1 }) {
  let count = columnCount;
  return (
    <div>
      {datas.map((item, index) => {
        if (item.fullWidth) {
          columnCount = 1;
        } else {
          columnCount = count;
        }

        const ReturnInputs = () => {
          switch (item.type) {
            case "accodion":
              return (
                <Accordion
                  sx={{
                    border: "2px solid #0050a0",
                    marginBottom: "7px",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={{
                      borderBottom: "1px solid #0050a0",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={ExcelIcon}
                      style={{ fontSize: "20px" }}
                    />

                    <Typography
                      sx={{
                        width: "90%",
                        marginLeft: "10px",
                        flexShrink: 0,
                        fontWeight: "bold",
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      sx={{
                        color: "text.secondary",
                      }}
                    >
                      {item.date}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography
                      sx={{
                        color: "text.secondary",
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {item.value}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              );
            default:
              return (
                <input
                  className="input"
                  style={{
                    backgroundColor: item.readOnly ? "#e4e4e4" : "#fff",
                  }}
                  type={item.inputType ? item.inputType : "text"}
                  inputMode={item.inputMode ? item.inputMode : "text"}
                  value={item.value}
                  onChange={(e) => item.onChange(e)}
                  readOnly={item.readOnly ? true : false}
                  onClick={(e) => {
                    if (item.clicked) {
                      item.onClick(e);
                    }
                  }}
                />
              );
          }
        };

        return (
          <div
            key={index}
            className={"content-box content-box-width" + columnCount}
          >
            <dt
              className={
                item.required
                  ? "formGroup_info_dt_required"
                  : "formGroup_info_dt"
              }
            >
              <span>{item.name}</span>
            </dt>
            <dd>{ReturnInputs()}</dd>
          </div>
        );
      })}
    </div>
  );
}

export default FormGroup;
